module.exports = __webpack_public_path__ + "img/gallery-img-5.7af8148d.jpg";